export default class WsDropdownSelectController {
  constructor() {
    this.isOpen = false;
  }

  toggleMenuOpenness() {
    this.isOpen = !this.isOpen;
  }

  closeMenu() {
    this.isOpen = false;
  }
}



// WEBPACK FOOTER //
// ./src/form/ws-dropdown-select/ws-dropdown-select.controller.js